import React, { useState } from "react";
import MissingParametersForWidgetPreview from "./MissingParametersForWidgetPreview";
import ReportingWidgetPreview from "./ReportingWidgetPreview";
const AvailableWidgetPreview = (props) => {
  const {
    widget: { parameters },
    searchId
  } = props;
  const [parameterValues, setParameterValues] = useState({});
  const requiredParameters = parameters.filter((p) => !p.optional && !p.defaultValue && p.needsBinding).filter((p) => !parameterValues[p.name]);
  const parameterSearchIds = Object.fromEntries(parameters.map((parameter) => [parameter.name, searchId]));
  if (requiredParameters && requiredParameters.length > 0) {
    return /* @__PURE__ */ React.createElement(
      MissingParametersForWidgetPreview,
      {
        parameters,
        parameterValues,
        onSubmit: setParameterValues,
        parameterSearchIds
      }
    );
  }
  return /* @__PURE__ */ React.createElement(ReportingWidgetPreview, { ...props, parameterValues });
};
export default AvailableWidgetPreview;
